import React, { Component } from "react";
import ReactDOM from "react-dom";

const listIdMapping = {
  cisionFilter_1: "cisionCurrentReports",
  cisionFilter_2: "cisionFinancialReports",
  cisionFilter_3: "cisionPresentations",
  epiNewsFilter_1: "epiNewsRegulatory",
  epiNewsFilter_2: "epiNewsNonRegulatory",
};

function validateJsonResponse(response) {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}, request failed`);
  }
  return response.json();
}

function getEpiNewsData(scope) {
  const fetchUrl = `${NewsListingEpiNewsUrl}/?id=${NewsListingContentRefId}`;
  const fetchSettings = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  fetch(fetchUrl, fetchSettings)
    .then(validateJsonResponse)
    .then((json) => {
      const items = json.EpiNewsFeed || [];
      const regulatory = [];
      const nonRegulatory = [];

      items.forEach((item) => {
        if (item.IsRegulatory) {
          regulatory.push(item);
        } else {
          nonRegulatory.push(item);
        }
      });

      scope.setState({ epiNewsRegulatory: regulatory.slice() });
      scope.setState({ epiNewsNonRegulatory: nonRegulatory.slice() });
    });
}

function getCisionData(scope) {
  const fetchSettings = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  };

  fetch(
    NewsListingPresentationsUrl,
    Object.assign(
      {
        body: JSON.stringify({
          ContentRefId: NewsListingContentRefId,
        }),
      },
      fetchSettings
    )
  )
    .then(validateJsonResponse)
    .then((json) => {
      const items = json.PresentationsFeed || [];

      scope.setState({ cisionPresentations: items.slice() });
    });

  fetch(
    NewsListingCurrentReportsUrl,
    Object.assign(
      {
        body: JSON.stringify({
          ContentRefId: NewsListingContentRefId,
          CisionUrl: NewsListingCisionUrl,
          CisionCacheTimeout: NewsListingCisionCacheTimeout,
          SelectedFilter: { Key: 2020 },
        }),
      },
      fetchSettings
    )
  )
    .then(validateJsonResponse)
    .then((json) => {
      const items = json.CisionNewsFeed || [];

      scope.setState({ cisionCurrentReports: items.slice() });
    });

  fetch(
    NewsListingFinancialReportsUrl,
    Object.assign(
      {
        body: JSON.stringify({
          ContentRefId: NewsListingContentRefId,
          CisionUrl: NewsListingCisionUrl,
          CisionCacheTimeout: NewsListingCisionCacheTimeout,
          SelectedFilter: { Key: 1 },
        }),
      },
      fetchSettings
    )
  )
    .then(validateJsonResponse)
    .then((json) => {
      const items = json.CisionNewsFeed || [];

      scope.setState({ cisionFinancialReports: items.slice() });
    });
}

function sourceFilterSelectHandler(filterId, scope) {
  scope.setState({ selectedSourceFilter: filterId });
  scope.setState({ selectedYearFilter: "" });
}

class NewsListingSourceFilter extends Component {
  constructor(props) {
    super(props);
  }

  renderClassName(id, scope) {
    const activeClassName =
      id === scope.state.selectedSourceFilter
        ? "news-listing--active-source"
        : "";

    return `news-listing__source ${activeClassName}`;
  }

  render() {
    const sources = this.props.sourceFilters.filter(
      (source) => source.text !== ""
    );

    return (
      <div className="news-listing__source-filter">
        {sources.map((filter, i) => (
          <div
            onClick={sourceFilterSelectHandler.bind(
              this,
              filter.id,
              this.props.scope
            )}
            className={this.renderClassName(filter.id, this.props.scope)}
            key={`source-control-${i}`}
            tabIndex="0"
            role="button"
          >
            {filter.text}
          </div>
        ))}
      </div>
    );
  }
}

class NewsListingYearFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayText: NewsListingTextShowAll,
    };
  }

  yearFilterSelectHandler(event) {
    const selectedYear = event.target.value;
    this.props.scope.setState({ selectedYearFilter: selectedYear });
    this.setState({ displayText: selectedYear || NewsListingTextShowAll });
  }

  populateFilter(displayText) {
    const yearsAvailable = {};
    const years = [];
    const selectedFilter = this.props.scope.state.selectedSourceFilter;
    const listData = this.props.scope.state[listIdMapping[selectedFilter]];

    if (listData !== undefined) {
      listData.forEach((item) => {
        yearsAvailable[item.PublishDate.substring(0, 4)] = true;
      });

      Object.keys(yearsAvailable).forEach((year) => {
        years.push(year);
      });

      years.sort().reverse();

      if (years.length > 1) {
        return (
          <div className="news-listing__year-filter-dropdown">
            <div className="news-listing__year-filter-display">
              {displayText}
            </div>
            <select onChange={this.yearFilterSelectHandler.bind(this)}>
              <option value="">{NewsListingTextShowAll}</option>
              {years.map((listItem, i) => {
                return (
                  <option value={listItem} key={`yearFilterItem-${i}`}>
                    {listItem}
                  </option>
                );
              })}
            </select>
          </div>
        );
      }
    }
  }

  render() {
    console.log("render yearsz");
    return (
      <div className="news-listing__year-filter">
        {this.populateFilter(this.state.displayText)}
      </div>
    );
  }
}

class ListView extends Component {
  constructor(props) {
    super(props);
  }

  renderEpiNewsItem(item, i) {
    return (
      <li className="news-listing__list-item-epi" key={`listItem-${i}`}>
        <div>
          <time dateTime={item.PublishDate}>
            {item.PublishDate.substring(0, 10)}
          </time>
        </div>
        <a href={item.Url}>{item.Title}</a>
      </li>
    );
  }

  renderCisionItem(item, i) {
    const title = item.Name.replace("Â ", " - ");
    const fileType = item.Files[0].FileName.split(".").pop().toUpperCase();

    return (
      <li className="news-listing__list-item-cision" key={`listItem-${i}`}>
        <div>
          <time dateTime={item.PublishDate}>
            {item.PublishDate.substring(0, 10)}
          </time>
        </div>
        <a target="_blank" href={item.Files[0].Url}>
          {title} ({fileType}){" "}
          {/* <span className="icon-arrow-up-right"></span> */}
        </a>
      </li>
    );
  }

  populateList() {
    const listData = this.props.state[
      listIdMapping[this.props.state.selectedSourceFilter]
    ];
    const selectedYear = this.props.state.selectedYearFilter;

    if (listData === undefined) {
      return (
        <div className="news-listing__wait-indicator">
          <em>{NewsListingTextLoading}</em>
        </div>
      );
    } else if (listData.length === 0) {
      return (
        <div className="news-listing__wait-indicator">
          <em>{NewsListingTextNoResults}</em>
        </div>
      );
    } else {
      return listData
        .filter(
          (listItem) =>
            selectedYear === "" ||
            listItem.PublishDate.substring(0, 4) === selectedYear
        )
        .map((listItem, i) => {
          if (listItem.Files) {
            return this.renderCisionItem(listItem, i);
          } else {
            return this.renderEpiNewsItem(listItem, i);
          }
        });
    }
  }

  render() {
    return (
      <div className="news-listing__list">
        <ul>{this.populateList()}</ul>
      </div>
    );
  }
}

class NewsListingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      epiNewsRegulatory: undefined,
      epiNewsNonRegulatory: undefined,
      cisionCurrentReports: undefined,
      cisionFinancialReports: undefined,
      cisionPresentations: undefined,
      selectedSourceFilter: "",
      currentYearFilters: [],
      selectedYearFilter: "",
    };
  }

  componentDidMount() {
    if (NewsListingCisionMode) {
      getCisionData(this);
      sourceFilterSelectHandler("cisionFilter_1", this);
    } else {
      getEpiNewsData(this);
      sourceFilterSelectHandler("epiNewsFilter_1", this);
    }
  }

  render() {
    return (
      <div className="news-listing__view">
        <NewsListingSourceFilter
          scope={this}
          sourceFilters={
            NewsListingCisionMode
              ? NewsListingCisionFilters
              : NewsListingEpiFilters
          }
        />
        <NewsListingYearFilter scope={this} />
        <ListView state={this.state} />
      </div>
    );
  }
}

class NewsListing {
  constructor(element) {
    this.element = element;
    this.view = element.querySelector(".news-listing__root");
    if (this.view != null) this.init();
  }

  init() {
    ReactDOM.render(<NewsListingView />, this.view);
  }
}

export default NewsListing;
